import React, { useState, useEffect } from 'react';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideshowImages = [
    "https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?auto=format&fit=crop&q=80&w=800",
    "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&q=80&w=800",
    "https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&q=80&w=800",
    "https://images.unsplash.com/photo-1571091718767-18b5b1457add?auto=format&fit=crop&q=80&w=800"
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideshowImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [slideshowImages.length]);

  return (
    <div className="bg-[#080808] text-white font-['Inter']">
      <style dangerouslySetInnerHTML={{ __html: `
        :root { --brushed-gold: #b8962d; }
        
        @keyframes truck-drift { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
        @keyframes wheel-rotation { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        
        /* Moving road forward */
        @keyframes road-travel { 
            from { background-position: -100px 0; } 
            to { background-position: 0 0; } 
        }
        
        .truck-chassis { animation: truck-drift 4s ease-in-out infinite; }
        .gold-spinner { animation: wheel-rotation 0.5s linear infinite; }
        
        .moving-road { 
          animation: road-travel 0.7s linear infinite;
          background-image: linear-gradient(90deg, #333 0%, #333 40px, transparent 40px, transparent 100px);
          background-size: 100px 100%;
        }

        .tire-blend {
          background: radial-gradient(circle at center, #1a1a1a 0%, #050505 100%);
          box-shadow: inset 0 0 20px rgba(0,0,0,0.8), 0 10px 20px rgba(0,0,0,0.5);
        }
      `}} />

      <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 px-4 bg-[#050505] overflow-hidden">
        
        {/* --- DYNAMIC ROAD --- */}
        <div className="absolute bottom-[13%] w-[200%] h-4 moving-road opacity-20"></div>
        
        <div className="truck-chassis relative w-full max-w-6xl z-10">
          
          {/* TRUCK TOP BODY */}
          <div className="flex flex-col md:flex-row items-stretch filter drop-shadow-[0_40px_60px_rgba(0,0,0,0.8)] relative z-10">
            
            {/* --- CABIN FRONT --- */}
            <div className="w-full md:w-[32%] bg-[#111] border-y border-l border-[#222] border-r-[15px] border-r-black rounded-t-[50px] md:rounded-tr-none md:rounded-l-[90px] p-6 relative">
              <div className="relative w-full h-[260px] md:h-[380px] bg-black rounded-t-[40px] md:rounded-tl-[80px] md:rounded-tr-lg overflow-hidden border border-[#222]">
                <img 
                  src={slideshowImages[currentSlide]} 
                  className="absolute inset-0 w-full h-full object-cover opacity-50 transition-opacity duration-1000"
                  alt="Cabin"
                />
              </div>

              {/* Headlights */}
              <div className="mt-8 flex justify-between px-4">
                <div className="w-14 h-6 bg-[#eab308] rounded-sm blur-[1px] shadow-[0_0_20px_rgba(234,179,8,0.4)]"></div>
                <div className="w-14 h-6 bg-[#eab308] rounded-sm blur-[1px] shadow-[0_0_20px_rgba(234,179,8,0.4)]"></div>
              </div>
            </div>

            {/* --- TRAILER / WINDOW SECTION --- */}
            <div className="w-full md:w-[68%] bg-[#111] border border-[#222] rounded-b-[40px] md:rounded-bl-none md:rounded-r-[50px] relative p-8 flex items-center justify-center min-h-[450px]">
               
               <div className="relative w-full h-[320px] md:h-[450px] bg-[#050505] border-t-2 border-[#b8962d] rounded-xl shadow-[inset_0_0_40px_rgba(0,0,0,0.8)] flex flex-col items-center justify-center">
                  <div className="text-center px-4">
                    <h1 className="font-['Bebas_Neue'] text-6xl md:text-9xl tracking-tight text-white leading-none mb-2">
                      PRIME <span className="text-[#b8962d]">EATS</span>
                    </h1>
                    <p className="text-gray-500 font-bold tracking-[0.4em] text-[10px] md:text-xs uppercase mb-10">
                      Westland, Michigan • Premium Smash
                    </p>
                    <button 
                      onClick={() => document.getElementById('menu').scrollIntoView({ behavior: 'smooth' })} 
                      className="border-2 border-[#b8962d] text-[#b8962d] px-12 py-4 hover:bg-[#b8962d] hover:text-black transition-all font-black tracking-widest text-xs"
                    >
                      ORDER HERE
                    </button>
                  </div>
                  
                  {/* Service Counter */}
                  <div className="absolute bottom-0 w-full h-3 bg-gradient-to-r from-[#1a1a1a] via-[#333] to-[#1a1a1a] border-t border-white/5 shadow-xl"></div>
               </div>
            </div>
          </div>

          {/* --- INTEGRATED WHEELS (Blended into the body) --- */}
          <div className="flex justify-around w-full mx-auto mt-[-60px] relative z-0 md:pl-[10%]">
             {[1, 2, 3].map((i) => (
                <div key={i} className="relative">
                  
                  {/* WHEEL ARCH (The 'Circle' around the tire to blend it) */}
                  <div className="absolute -top-4 -left-4 -right-4 h-[60%] bg-[#080808] border-t-2 border-x-2 border-[#222] rounded-t-full shadow-lg z-0"></div>
                  
                  {/* The Tire */}
                  <div className="relative z-10 w-28 h-28 md:w-44 md:h-44 tire-blend rounded-full border-[15px] border-[#0a0a0a] flex items-center justify-center">
                    
                    {/* The Rim Hub */}
                    <div className="w-[85%] h-[85%] rounded-full bg-[#111] border border-[#222] flex items-center justify-center relative overflow-hidden">
                       
                       {/* Spinning Gold Accent Line */}
                       <div className="gold-spinner absolute w-full h-full flex items-center justify-center">
                          <div className="w-[1px] h-full bg-[#b8962d]/50 shadow-[0_0_15px_rgba(184,150,45,0.4)]"></div>
                          <div className="absolute w-full h-[1px] bg-[#b8962d]/10"></div>
                       </div>

                       {/* Central Cap */}
                       <div className="relative z-10 w-8 h-8 md:w-12 md:h-12 bg-[#050505] rounded-full border border-[#222] flex items-center justify-center">
                          <div className="w-2 h-2 bg-[#b8962d] rounded-full"></div>
                       </div>
                    </div>
                  </div>

                  {/* Ground Shadow */}
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-[90%] h-4 bg-black/80 blur-lg rounded-full"></div>
                </div>
             ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;